module.exports = __webpack_public_path__ + "img/detail-nav.a13c8c77.svg";